<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import KanbanApi from 'dashboard/api/kanban';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const store = useStore();
const pipelines = ref([]);
const selectedPipeline = ref(null);
const selectedColumn = ref(null);

// Computed para o valor selecionado
const value = computed({
  get() {
    return props.modelValue || [];
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

// Carregar pipelines ao montar o componente
onMounted(async () => {
  try {
    const response = await KanbanApi.getPipelines();
    pipelines.value = response.data || [];

    // Se já houver um valor selecionado, inicializar os dropdowns
    if (value.value.length > 0) {
      const [pipelineId, columnId] = value.value;
      selectedPipeline.value = pipelines.value.find(p => p.id === pipelineId);
      if (selectedPipeline.value) {
        selectedColumn.value = selectedPipeline.value.kanban_columns?.find(
          c => c.id === columnId
        );
      }
    }
  } catch (error) {
    console.error('Erro ao carregar pipelines:', error);
  }
});

// Quando o funil é selecionado
const onPipelineChange = () => {
  selectedColumn.value = null;
  value.value = [];
};

// Quando a coluna é selecionada
const onColumnChange = () => {
  if (selectedPipeline.value && selectedColumn.value) {
    value.value = [selectedPipeline.value.id, selectedColumn.value.id];
  }
};

// Computed para as colunas do funil selecionado
const availableColumns = computed(() => {
  return selectedPipeline.value?.kanban_columns || [];
});
</script>

<template>
  <div class="flex flex-col gap-2 w-full">
    <!-- Pipeline Selection -->
    <div class="multiselect-wrap--small">
      <select
        v-model="selectedPipeline"
        class="m-0 text-sm"
        @change="onPipelineChange"
      >
        <option :value="null">Selecione um funil</option>
        <option
          v-for="pipeline in pipelines"
          :key="pipeline.id"
          :value="pipeline"
        >
          {{ pipeline.name }}
        </option>
      </select>
    </div>

    <!-- Column Selection (only shown when pipeline is selected) -->
    <div v-if="selectedPipeline" class="multiselect-wrap--small">
      <select
        v-model="selectedColumn"
        class="m-0 text-sm"
        @change="onColumnChange"
      >
        <option :value="null">Selecione uma coluna</option>
        <option
          v-for="column in availableColumns"
          :key="column.id"
          :value="column"
        >
          {{ column.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<style scoped>
.multiselect-wrap--small {
  @apply w-full;
}

select {
  @apply w-full;
}
</style>
